import React from 'react';
import { useGameStore } from '../stores/gameStore';
import { Heart, Sparkles, RefreshCw } from 'lucide-react';

const ResultScreen: React.FC = () => {
  const { charA, charB, gameResult: result, resetToSelect: onRestart } = useGameStore();
  if (!charA || !charB || !result) return null;

  const score = parseInt(result.score, 10) || 0;
  const isGoodEnding = score >= 80;

  return (
    <div
      className={`h-full flex flex-col items-center justify-center p-6 overflow-y-auto text-center relative ${isGoodEnding
          ? 'bg-gradient-to-b from-cream to-coral-100'
          : 'bg-gradient-to-b from-cream to-sky-100'
        }`}
    >
      {/* Heart-fall decoration for good endings */}
      {isGoodEnding && (
        <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
          {[12, 16, 10, 20, 14, 8, 18, 11].map((size, i) => (
            <Heart
              key={i}
              size={size}
              className="absolute text-coral-500/30 fill-coral-500/20 animate-heart-fall"
              style={{
                left: `${10 + i * 12}%`,
                animationDelay: `${i * 0.5}s`,
                animationDuration: `${3 + (i % 3)}s`,
              }}
            />
          ))}
        </div>
      )}

      <div className="w-full max-w-md bg-white rounded-3xl p-8 border border-[#E5E0D8] shadow-xl relative overflow-hidden z-10">
        {/* Category label */}
        <h2 className="text-xs tracking-widest text-[#9CA3AF] mb-2 flex items-center justify-center gap-1">
          <Sparkles size={12} className="text-amber-accent" />
          约会结果揭晓
          <Sparkles size={12} className="text-amber-accent" />
        </h2>

        {/* Result title */}
        <h1
          className={`text-2xl md:text-3xl font-black mb-6 leading-tight ${isGoodEnding ? 'text-coral-500' : 'text-sky-accent'
            }`}
        >
          {result.title}
        </h1>

        {/* Character avatars */}
        <div className="flex justify-center items-center -space-x-4 mb-8">
          <img
            src={charA.avatar}
            className="w-20 h-20 rounded-full border-4 border-white shadow-md z-0"
            alt={charA.name}
          />
          <Heart
            size={24}
            className={`z-20 ${isGoodEnding ? 'text-coral-500 fill-coral-500' : 'text-sky-accent'}`}
          />
          <img
            src={charB.avatar}
            className="w-20 h-20 rounded-full border-4 border-white shadow-md z-10"
            alt={charB.name}
          />
        </div>

        {/* Description */}
        <p className="text-sm text-[#6B7280] mb-8 leading-relaxed">
          {result.description}
        </p>

        {/* Score card */}
        <div className="mb-8">
          <div className="bg-cream rounded-2xl p-4 border border-[#E5E0D8] inline-block min-w-[140px]">
            <span className="block text-xs text-[#9CA3AF] mb-1">默契指数</span>
            <span className="text-3xl font-black text-coral-500">{result.score}</span>
          </div>
        </div>

        {/* CTA */}
        <button
          onClick={onRestart}
          className="w-full py-4 rounded-full bg-gradient-to-r from-coral-500 to-amber-accent hover:from-coral-700 hover:to-coral-500 text-white font-bold text-lg tracking-wider shadow-lg transition-all hover:shadow-xl flex items-center justify-center gap-2"
        >
          <RefreshCw size={18} />
          再来一局！
        </button>
      </div>
    </div>
  );
};

export default ResultScreen;
